import styled from 'styled-components'

export const StatsChartContainer = styled.div`
    .loading {
        color: white;
    }
`;